import "./Partners.css";

const Partners = () => {
  const partners = [
    {
      id: 1,
      name: "DHL",
      logo: "/assets/images/partners/dhl.jpg",
      category: "logistics",
    },
    {
      id: 2,
      name: "Fidelity Bank",
      logo: "/assets/images/partners/fidelity.jpg",
      category: "banking",
    },
    {
      id: 3,
      name: "Providus Bank",
      logo: "/assets/images/partners/providus.jpg",
      category: "banking",
    },
    {
      id: 4,
      name: "VFD Bank",
      logo: "/assets/images/partners/vfd.jpg",
      category: "banking",
    },
  ];

  return (
    <section className="partners-section">
      <div className="partners-section__container">
        <div className="partners-section__header">
          <h2 className="partners-section__title">
            Trusted by Leading Institutions
          </h2>
          <p className="partners-section__subtitle">
            We work with top-tier partners to provide you with the best
            financial and business solutions.
          </p>
        </div>

        <div className="partners-section__content">
          <div className="partners-section__grid">
            {partners.map((partner) => (
              <div key={partner.id} className="partners-section__card">
                <div className="partners-section__logo-container">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="partners-section__logo"
                    loading="lazy"
                  />
                </div>
                <div className="partners-section__overlay">
                  <span className="partners-section__name">{partner.name}</span>
                  <span className="partners-section__category">
                    {partner.category}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="partners-section__stats">
          <div className="partners-section__stat">
            <div className="partners-section__stat-number">50+</div>
            <div className="partners-section__stat-label">Partners</div>
          </div>
          <div className="partners-section__stat">
            <div className="partners-section__stat-number">₦2B+</div>
            <div className="partners-section__stat-label">
              Value Facilitated
            </div>
          </div>
          <div className="partners-section__stat">
            <div className="partners-section__stat-number">10K+</div>
            <div className="partners-section__stat-label">Happy Customers</div>
          </div>
          <div className="partners-section__stat">
            <div className="partners-section__stat-number">24/7</div>
            <div className="partners-section__stat-label">
              Support Available
            </div>
          </div>
        </div>

        <div className="partners-section__cta">
          <h3 className="partners-section__cta-title">Ready to Get Started?</h3>
          <p className="partners-section__cta-text">
            Let us connect you with the right partner for your needs.
          </p>
          <a href="/contact-us" className="partners-section__cta-button">
            Apply Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Partners;
